import React from "react";
import { SceneInner, SceneWrapper, SettingsCog } from "./styles";
import Settings from "../settings/settings";
import { useApp } from "../../state/app";
import "@reach/tooltip/styles.css";

type Props = {
  children: any;
  showSettings?: boolean;
};
export default function Scene({ children, showSettings = true }: Props) {
  const { showSetting, setShowSetting } = useApp();
  const ref = React.useRef<HTMLButtonElement>(null);
  const mountedRef = React.useRef(false);
  const [mouseOver, setMouseOver] = React.useState(false);

  React.useEffect(() => {
    if (!showSetting && ref.current && mountedRef.current) {
      ref.current.focus();
    }
    mountedRef.current = true;
  }, [showSetting]);

  return (
    <SceneWrapper>
      {showSettings && (
        // <Tooltip label="Menu" aria-label="Menu">
        <SettingsCog
          onClick={() => setShowSetting(true)}
          onMouseOver={() => setMouseOver(true)}
          onMouseLeave={() => setMouseOver(false)}
          tabIndex={showSetting ? -1 : 0}
          aria-label="Menu"
          aria-haspopup={true}
          aria-hidden={showSetting}
          focus={mouseOver}
          ref={ref}
        >
          <span aria-label="Menu" id="menu">
            Menu
          </span>
        </SettingsCog>
      )}
      {showSetting && (
        <Settings open={showSetting} setOpen={() => setShowSetting(false)} />
      )}
      <SceneInner>{children}</SceneInner>
    </SceneWrapper>
  );
}
